const validatePhone = phone => {
    const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return phoneRegex.test(phone);
};

const validateEmail = email => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
};

const validateZip = zip => {
    const zipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
    return zipRegex.test(zip);
};

export const validators = {
    isRequired: value => !!value && !!value.length,
    email: email => validateEmail(email),
    phone: phone => validatePhone(phone),
    zip: zip => validateZip(zip)
};

/**
 * Creates a form validation object from values
 * @param {{ email: string, firstName: string }} formValues
 */
export const getLeadFormValidation = ({
    email,
    firstName,
    lastName,
    zip,
    phone
}) => ({
    email: {
        required: validators.isRequired(email),
        pattern: validators.email(email)
    },
    firstName: {
        required: validators.isRequired(firstName)
    },
    lastName: {
        required: validators.isRequired(lastName)
    },
    phone: {
        required: validators.isRequired(phone),
        pattern: validators.phone(phone)
    },
    zip: {
        required: validators.isRequired(zip),
        pattern: validators.zip(zip)
    }
});

export const isFieldValid = (field) =>
    !Object.keys(field).filter(key => !field[key])
        .length;

export const isFormValid = validationObj =>
    !Object.keys(validationObj).filter(
        parentKey =>
            Object.keys(validationObj[parentKey]).filter(
                childKey => !validationObj[parentKey][childKey]
            ).length
    ).length;

export default { getLeadFormValidation, isFieldValid, isFormValid };


// WEBPACK FOOTER //
// ./src/utils/validation.js